import i18n from '@/i18n'
import { optionType } from '@/design-system/molecules/DropdownStandard.vue'

export function getPriorityColorLight(priority: string) {
  switch (priority) {
    case 'HIGHEST':
      return '#FFCCC7'
    case 'HIGH':
      return '#FFD8BF'
    case 'MEDIUM':
      return '#FFE7BA'
    case 'LOW':
      return '#D6E4FF'
    case 'LOWEST':
      return '#EFDBFF'
    default:
      return '#E0E0E0'
  }
}
export function getPriorityColor(priority: string) {
  switch (priority) {
    case 'HIGHEST':
      return '#FF4D4F'
    case 'HIGH':
      return '#FF7A45'
    case 'MEDIUM':
      return '#FFA940'
    case 'LOW':
      return '#597EF7'
    case 'LOWEST':
      return '#9254DE'
    default:
      return '#767676'
  }
}
export function getPriorityOptions(selectedPriority: string): optionType[] {
  const { t } = i18n.global
  return [
    {
      id: 'HIGHEST',
      name: t('general__text__highest'),
      selected: selectedPriority === 'HIGHEST',
      disabled: false
    },
    {
      id: 'HIGH',
      name: t('general__text__high'),
      selected: selectedPriority === 'HIGH',
      disabled: false
    },
    {
      id: 'MEDIUM',
      name: t('general__text__medium'),
      selected: selectedPriority === 'MEDIUM',
      disabled: false
    },
    {
      id: 'LOW',
      name: t('general__text__low'),
      selected: selectedPriority === 'LOW',
      disabled: false
    },
    {
      id: 'LOWEST',
      name: t('general__text__lowest'),
      selected: selectedPriority === 'LOWEST',
      disabled: false
    }
  ]
}

export function getStatusColorLight(priority: string) {
  switch (priority) {
    case 'NOT_IN_PROGRESS':
      return '#FFCCC7'
    case 'ON_GOING':
      return '#BAE7FF'
    case 'ON_HOLD':
      return '#FFD8BF'
    case 'FINISHED':
      return '#D9F7BE'
    case 'CANCELLED':
      return '#B5F5EC'
    default:
      return '#E0E0E0'
  }
}

export function getStatusOptions(selectedStatus: string) {
  const { t } = i18n.global
  return [
    {
      id: 'NOT_IN_PROGRESS',
      name: t('general__data__ticket-not_in_progress'),
      selected: selectedStatus === 'NOT_IN_PROGRESS',
      disabled: false
    },
    {
      id: 'ON_GOING',
      name: t('general__data__ticket-on_going'),
      selected: selectedStatus === 'ON_GOING',
      disabled: false
    },
    {
      id: 'ON_HOLD',
      name: t('general__data__ticket-on_hold'),
      selected: selectedStatus === 'ON_HOLD',
      disabled: false
    },
    {
      id: 'FINISHED',
      name: t('general__data__ticket-finished'),
      selected: selectedStatus === 'FINISHED',
      disabled: false
    },
    {
      id: 'CANCELLED',
      name: t('general__data__ticket-cancelled'),
      selected: selectedStatus === 'CANCELLED',
      disabled: false
    }
  ]
}

// Keeping outcommented function below in case backend won't improve sorting on dueDate
// export function sortDueDate(a, b) {
//   // equal items sort according to title
//   if (a.dueDate === b.dueDate) {
//     return a.title > b.title ? 1 : -1
//   }
//   // nulls sort after anything else
//   if (a.dueDate === null) {
//     return 1
//   }
//   if (b.dueDate === null) {
//     return -1
//   }
//   return a.dueDate > b.dueDate ? 1 : -1
// }

export function translatedPriority(priority) {
  const { t } = i18n.global
  switch (priority) {
    case 'HIGHEST':
      return t('general__text__highest')
    case 'HIGH':
      return t('general__text__high')
    case 'MEDIUM':
      return t('general__text__medium')
    case 'LOW':
      return t('general__text__low')
    case 'LOWEST':
      return t('general__text__lowest')
    default:
      return t('general__text__unknown')
  }
}

export function translatedStatus(status) {
  const { t } = i18n.global
  switch (status) {
    case 'NOT_IN_PROGRESS':
      return t('general__data__ticket-not_in_progress')
    case 'ON_GOING':
      return t('general__data__ticket-on_going')
    case 'ON_HOLD':
      return t('general__data__ticket-on_hold')
    case 'FINISHED':
      return t('general__data__ticket-finished')
    case 'CANCELLED':
      return t('general__data__ticket-cancelled')
    default:
      return t('general__text__unknown')
  }
}
